import Caldav from '../../services/caldavjs-nextcloud';
import icalParser from '../../services/caldavjs-nextcloud/ical-parser';
import moment from 'moment-timezone';
import { getBasicAuthCredentials } from '../../services/auth-credentials';

const settings = {
  username: '',
  password: '',
  server: window.NEXTCLOUD_URL,
  basePath: '/remote.php/dav',
  timezone: 'Europe/Madrid',
  principalPath: '/principals/users',
  parserLogging: true
};

let attendees = [];

export const caldav = new Caldav(settings);

export const createContact = async (contact, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const con = await cd.createContact({
    name: contact.name,
    email: contact.email,
    phone: contact.phone,
    mobilePhone: contact.mobilePhone,
    guid: contact.guid,
    categories: contact.categories,
    filename: contact.filename
  });
  return con;
};

export const getContacts = async (user, mailAccount, lexonToken, contactString) => new Promise(async (resolve, reject) => {
  try {
    const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Basic ${basicAuthToken}`);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("OCS-APIRequest", "true");
    myHeaders.append("Content-Type", "application/xml");

    const raw = "<d:propfind \r\nxmlns:d=\"DAV:\" \r\nxmlns:cs=\"http://calendarserver.org/ns/\"\r\nxmlns:card=\"urn:ietf:params:xml:ns:carddav\">\r\n    <d:prop>\r\n        <d:displayname />\r\n        <cs:getctag />\r\n        <card:address-data />\r\n    </d:prop>\r\n</d:propfind>";

    const requestOptions = {
      method: 'PROPFIND',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${window.NEXTCLOUD_URL}/remote.php/dav/addressbooks/users/${mailAccount}/${contactString}/`, requestOptions)
      .then(response => {
        if (response.ok) {
          return response.text();
        }
        throw new Error(`Status:${response.status} ` + ` Headers:${response.headers}`);
      })
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        console.error('error', error);
        reject(error);
      });
  } catch (error) {
    reject(error);
  }
});

// Get calendars
export const calendarList = async (user, mailAccount, lexonToken) => {
  let calendars = null;
  if (lexonToken) {
    const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
    const cd = new Caldav({
      ...settings,
      username: mailAccount,
      basicAuthToken
    });
    calendars = await cd.listCalendars({});
  }
  if (calendars === 'Not Account') {
    throw new Error("Not Account");
  }
  return listCalendarParser(calendars ? calendars.filter(c => c.ctag !== undefined) : []);
};

// Create Calendar
export const createCalendar = async (calendar, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });
  const cal = await cd.createCalendar({
    name: calendar.summary,
    timezone: 'Europe/Madrid', // only to override settings
    filename: `/calendars/${mailAccount}/${calendar.summary}`,
    color: calendar.color,
    description: calendar.description
  });
  return cal;
};

// Update Calendar
export const updateCalendarList = async (calendarId, calendar, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.updateCalendar({
    name: calendar.summary,
    timezone: 'Europe/Madrid', // only to override settings
    filename: calendarId,
    color: calendar.backgroundColor,
    description: calendar.description
  });
  return cal;
};

export const test = async (calendarId, calendar, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.test({
    name: calendar.summary,
    timezone: 'Europe/Madrid', // only to override settings
    filename: calendarId,
    color: calendar.backgroundColor,
    description: calendar.description
  });
  return cal;
};

export const publishCalendarLink = async (calendarId, calendar, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.publishCalendarLink({
    name: calendar.summary,
    timezone: 'Europe/Madrid', // only to override settings
    filename: calendarId,
    color: calendar.backgroundColor,
    description: calendar.description
  });
  return cal;
};

export const publishCalendarLink2 = async (calendarId, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.publishCalendarLink({
    filename: calendarId
  });
  return cal;
};

export const test2 = async (calendarId, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.test({
    filename: calendarId
  });
  return cal;
};

export const unpublishCalendarLink2 = async (calendarId, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.unpublishCalendarLink({
    filename: calendarId
  });
  return cal;
};

export const unpublishCalendarLink = async (calendarId, calendar, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.unpublishCalendarLink({
    name: calendar.summary,
    timezone: 'Europe/Madrid', // only to override settings
    filename: calendarId,
    color: calendar.backgroundColor,
    description: calendar.description
  });
  return cal;
};

export const shareCalendar = async (calendarId, permissions, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.shareCalendar({
    filename: calendarId,
    contact: permissions.scope.value,
    action: permissions.role
  });

  return cal;
};

export const invitedUsers = async (calendarId, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.invitedUsers({
    filename: calendarId
  });

  return cal;
};


// Delete Calendar

export const deleteCalendar = async (calendar, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.deleteCalendar({
    filename: calendar
  });
  return cal;
};

// Delete Calendar trash bin
export const deleteCalendarTrashBin = async (calendar, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const cal = await cd.deleteCalendar({
    filename: calendar
  });
  return cal;
};

// Get events to deprecate
export const listEvents = async (calendar, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const events = await cd.listEvents({
    filename: calendar?.replace(settings.basePath, ''),
    start: '20200601T000000Z',
    end: "20240630T115959Z"
  });
  return listEventsParser(events);
};

// Get events
export const getEventList = async (calendar, user, mailAccount, lexonToken, selectedDate) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  let dateToUse = selectedDate;

  if (!(dateToUse instanceof Date) || isNaN(dateToUse.getTime())) {
    dateToUse = new Date();
  }
  const splittedDate = dateToUse.toISOString().split("T")[0].split("-");

  const minDate = new Date(
    parseInt(splittedDate[0]),
    parseInt(splittedDate[1]) - 1,
    1
  );
  const maxDate = new Date(
    parseInt(splittedDate[0]),
    parseInt(splittedDate[1]),
    0
  );

  minDate.setMonth(minDate.getMonth() - 1);
  maxDate.setMonth(maxDate.getMonth() + 1);

  const events = await cd.listEvents({
    filename: calendar?.replace(settings.basePath, ''),
    start: minDate.toISOString(),
    end: maxDate.toISOString()
  });

  return listEventsParser(events);
};

// Get events by explicit date range
export const getEventListByRange = async (calendar, user, mailAccount, lexonToken, start, end) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const startDate = new Date(start);
  const endDate = new Date(end);
  const hasValidRange = !isNaN(startDate.getTime()) && !isNaN(endDate.getTime());

  if (!hasValidRange) {
    return getEventList(calendar, user, mailAccount, lexonToken, new Date());
  }

  const events = await cd.listEvents({
    filename: calendar?.replace(settings.basePath, ''),
    start: startDate.toISOString(),
    end: endDate.toISOString()
  });

  return listEventsParser(events);
};

// search events
const getEventBySearch = (resourceUrl, user, mailAccount, lexonToken) => new Promise(async (resolve, reject) => {
  try {
    const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Basic ${basicAuthToken}`);
    myHeaders.append("Content-Type", "application/xml");
    myHeaders.append("Accept", "application/json");

  const requestCalendarOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  fetch(`${window.NEXTCLOUD_URL}${resourceUrl}`, requestCalendarOptions)
    .then(response => {
      if (response.ok) {
        return response.text();
      }
      throw new Error(`Status:${response.status} ` + ` Headers:${response.headers}`);
    })
    .then(result => {
      const event = {};
      icalParser.convert(result, true, (err, parsed) => {
        parsed = parsed.VCALENDAR[0].VEVENT[0];
        const parsedKeys = Object.keys(parsed);

        if (event.start === undefined) {
          const dtStart = parsedKeys.filter(prop => prop.includes('DTSTART'));
          event.start = parsed[dtStart];
        }
        if (event.end === undefined) {
          const dtEnd = parsedKeys.filter(prop => prop.includes('DTEND'));
          event.end = parsed[dtEnd];
        }
        //Check all day events
        const startAllDay = parsedKeys.find(prop => prop.includes('DTSTART;VALUE=DATE'));
        const endAllDay = parsedKeys.find(prop => prop.includes('DTSTART;VALUE=DATE'));
        event.allDay = (startAllDay && endAllDay) ? true : false;
        event.summary = parsed.SUMMARY ? parsed.SUMMARY.replaceAll('\\n', '\n').replaceAll('\\\\', '%5C').replaceAll('\\', '').replaceAll('%5C', '\\').replaceAll('&amp;', '&') : parsed.SUMMARY;
        event.location = parsed.LOCATION;
        event.description = parsed.DESCRIPTION ? parsed.DESCRIPTION.replaceAll('\\n', '\n').replaceAll('\\\\', '%5C').replaceAll('\\', '').replaceAll('%5C', '\\').replaceAll('&amp;', '&') : parsed.DESCRIPTION;
        event.color = parsed.COLOR;
        event.categories = parsed.CATEGORIES;
        event.lexonActuation = parsed["X-ACTUATION"];
        event.companySelected = parsed["X-COMPANY"];
        event.idCompanySelected = parsed["X-IDCOMPANY"];
        event.idEventAction = parsed["X-IDEVENTACTION"];
        event.idEventLexon = parsed["X-IDEVENTLEXON"];
        event.visibility = parsed.CLASS;
        event.href = resourceUrl;
        event.json = parsed;
        resolve(event);
      });
    })
    .catch(error => {
      console.error('error', error);
      reject(error);
    });
  } catch (error) {
    reject(error);
  }
});

export const getSearchEventList = async (user, mailAccount, lexonToken, searchData, calendars) =>
  new Promise(async (resolve, reject) => {
    try {
      const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Basic ${basicAuthToken}`);
      myHeaders.append("Accept", "application/json");
      myHeaders.append("OCS-APIRequest", "true");
      myHeaders.append("Content-Type", "application/xml");

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      let queryString;

      if (!searchData.dateStart) {
        queryString = `term=${searchData.summary}&limit=${1000}&from=%2Fapps%2Fcalendar%2FdayGridMonth%2Fnow"`;
      } else {
        const dateStart = moment(searchData.dateStart)
          .startOf("day")
          .tz('Europe/Madrid')
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss[Z]");
        const dateEnd = moment(searchData.dateEnd)
          .endOf("day")
          .tz('Europe/Madrid')
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss[Z]");
        queryString = `term=${searchData.summary}&since=${dateStart}&until=${dateEnd}&limit=${1000}&from=/apps/calendar/dayGridMonth/now"`;
      }

      fetch(`${window.NEXTCLOUD_URL}/ocs/v2.php/search/providers/calendar/search?${queryString}`, requestOptions)
        .then(response => {
          if (response.ok) {
            return response.text();
          }
          throw new Error(`Status:${response.status} ` + ` Headers:${response.headers}`);
        })
        .then(async result => {
          const resultObj = JSON.parse(result);
          let newEvents = [];
          for (let index = 0; index < resultObj.ocs.data.entries.length; index++) {
            const element = resultObj.ocs.data.entries[index];
            const resourceUrl = window.atob(element.resourceUrl.split('/')[7]);
            const exitsSelectedCalender = calendars.some(x =>
              (
                decodeURIComponent(x.id.split('/')[5]) === decodeURIComponent(resourceUrl.split('/')[5])
              ));

            if (exitsSelectedCalender) {
              const newData = await getEventBySearch(resourceUrl, user, mailAccount, lexonToken);
              newEvents = [...newEvents, {...newData}];
            }
          }
          newEvents = listEventsParser(newEvents);
          return resolve(newEvents);
        })
        .catch(error => {
          console.error('error', error);
          reject(error);
        });
    } catch (error) {
      reject(error);
    }
  });

// search events
export const getSearchDateEventList = async (calendar, user, mailAccount, lexonToken, searchData) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const events = await cd.searchEvents({
    filename: calendar?.replace(settings.basePath, ''),
    start: searchData.dateStart,
    end: searchData.dateEnd
  });
  return listEventsParser(events);
};

// Get events
export const getEventById = async (user, mailAccount, lexonToken, idCalendar, eventId) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });
  const events = await cd.eventById({
    filename: idCalendar,
    href: eventId
  });
  return listEventsParser(events);
};

export const getEventByDate = async (user, mailAccount, lexonToken, idCalendar, eventInfo) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });
  const events = await cd.listEvents({
    filename: idCalendar,
    start: eventInfo.start,
    end: eventInfo.end
  });
  return listEventsParser(events);
};

// Create and update event
export const addCalendarEvent = async (calendar, event, user, mailAccount, lexonToken, returnPayload = false) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });
  const response = await cd.createEvent(event, returnPayload);
  return response;
};

export const deleteCalendarEvent = async (filename, user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });

  const response = await cd.deleteEvent({
    filename: filename
  });
  return response;
};

function listEventsParser(list) {
  let listParse = [];
  if (list.length > 0) {
    for (let i = 0; i < list.length; i++) {
      attendees = [];
      let recurrenceRule = [];
      if (list[i].json.RRULE != undefined) {
        recurrenceRule = [`RRULE:${list[i].json.RRULE}`];
      } else {
        recurrenceRule = null;
      }

      let reminders = [];
      if (list[i].json.VALARM) {
        reminders = getReminders(list[i].json.VALARM);
        list[i].json.VALARM = JSON.stringify(list[i].json.VALARM);
      }
      attendees = getAttendees(list[i].json);

      const start = list[i].allDay ? moment.tz(list[i].start, 'Europe/Madrid').format('YYYY-MM-DD HH:mm') :
        moment.tz(list[i].start, 'Europe/Madrid').local().format('YYYY-MM-DD HH:mm');

      const end = list[i].allDay ? moment.tz(list[i].end, 'Europe/Madrid').format('YYYY-MM-DD HH:mm') :
        moment.tz(list[i].end, 'Europe/Madrid').local().format('YYYY-MM-DD HH:mm');
      const newData = {
        id: list[i].href,
        filename: list[i].href,
        summary: list[i].summary,
        location: list[i].location,
        description: list[i].description,
        start: { dateTime: new Date(start), timeZone: 'UTC' },
        end: { dateTime: new Date(end), timeZone: 'UTC' },
        IsAllDay: list[i].allDay,
        //isSensitivity: list[i].sensitivity === 'normal' ? false : true,
        recurrence: recurrenceRule,
        ImageName: "lefebvre",
        attendees: attendees,
        categories: list[i].categories,
        color: list[i].color,
        reminders: reminders,
        lexonActuation: list[i].lexonActuation,
        companySelected: list[i].companySelected,
        idCompanySelected: list[i].idCompanySelected,
        idEventAction: list[i].idEventAction,
        idEventLexon: list[i].idEventLexon,
        visibility: list[i].visibility,
        status: list[i].json.STATUS
      };
      listParse = [...listParse, newData];
    }
  }
  let result;
  let items;
  items = ({ items: listParse });
  result = ({ result: items });
  return result;
}


function getReminders(alarms) {
  const reminders = [];
  const alarmsQueue = Array.isArray(alarms) ? [...alarms] : [alarms];

  while (alarmsQueue.length > 0) {
    const alarm = alarmsQueue.shift();

    if (!alarm || typeof alarm !== 'object') {
      continue;
    }

    const parsedKeys = Object.keys(alarm);
    const triggerKey = parsedKeys.find(prop => prop.includes('TRIGGER'));
    const triggerValue = triggerKey ? alarm[triggerKey] : null;

    if (typeof triggerValue === 'string') {
      const time = moment.duration(triggerValue, moment.ISO_8601);
      const timeMinutes = Math.abs(time.asMinutes());

      if (Number.isFinite(timeMinutes)) {
        reminders.push({
          method: 'email',
          minutes: timeMinutes
        });
      }
    }

    if (alarm.VALARM) {
      const nestedAlarms = Array.isArray(alarm.VALARM)
        ? alarm.VALARM
        : [alarm.VALARM];
      alarmsQueue.push(...nestedAlarms);
    }
  }

  return reminders;
}

function getAttendees(json) {
  const isValidEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);

  const extractAttendeeEmail = (value, includeCN = false) => {
    if (typeof value !== "string") {
      return null;
    }

    const normalized = value.replace(/^"+|"+$/g, '').trim();

    const emailParamMatch = normalized.match(/(?:^|[;:])EMAIL=([^;:"]+)/i);
    if (emailParamMatch && emailParamMatch[1]) {
      const email = emailParamMatch[1].trim();
      if (isValidEmail(email)) {
        return email;
      }
    }

    if (includeCN) {
      const cnParamMatch = normalized.match(/(?:^|[;:])CN=([^;:"]+)/i);
      if (cnParamMatch && cnParamMatch[1]) {
        const cnEmail = cnParamMatch[1].trim();
        if (isValidEmail(cnEmail)) {
          return cnEmail;
        }
      }
    }

    const mailtoMatch = normalized.match(/mailto:?([^;"\s]+)/i);
    if (mailtoMatch && mailtoMatch[1]) {
      const mailtoEmail = mailtoMatch[1].trim();
      if (isValidEmail(mailtoEmail)) {
        return mailtoEmail;
      }
    }

    const genericEmailMatch = normalized.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
    if (genericEmailMatch && genericEmailMatch[0]) {
      return genericEmailMatch[0].trim();
    }

    return null;
  };

  const newAttendees = [];
  const seenEmails = new Set();
  for (const key in json) {
    if (key.startsWith("ATTENDEE") && json[key]) {
      const attendeeStr = json[key];
      const attendeeEmailFromKey = extractAttendeeEmail(key, true);

      // Si es un string tipo "E-STATUS=1.2:mailto:joeldetrinidad@gmail.com"
      if (typeof attendeeStr === "string") {
        const email = attendeeEmailFromKey || extractAttendeeEmail(attendeeStr);
        if (email && !seenEmails.has(email)) {
          seenEmails.add(email);
          newAttendees.push({
            email: email,
            responseStatus: "needsAction"
          });
        }
      }
      // Si es un string tipo "ATTENDEE;CN=...;EMAIL=...;SCHEDUL:E-STATUS=1.2:mailto:..."
      else if (Array.isArray(attendeeStr)) {
        attendeeStr.forEach(str => {
          const email = attendeeEmailFromKey || extractAttendeeEmail(str);
          if (email && !seenEmails.has(email)) {
            seenEmails.add(email);
            newAttendees.push({
              email: email,
              responseStatus: "needsAction"
            });
          }
        });
      }
    }
  }
  return newAttendees;
}

function listCalendarParser(list) {
  const listParse = [];

  if (list.length > 0) {
    for (let i = 0; i < list.length; i++) {
      let roll;
      const aux = list[i].owner.split('/');
      const aux2 = list[i].href.split('/');
      const owner = aux[aux.length - 2];
      const calendarUser = aux2[aux2.length - 3];

      if (owner === calendarUser) {
        roll = "owner";
      } else if (list[i].privilege.privilege.find(x => Object.keys(x).find(z => z === "write"))) {
        roll = "read-write";
      } else if (list[i].privilege.privilege.find(x => Object.keys(x).find(z => z === "read"))) {
        roll = "read";
      }

      const primary = false;
      let color = "";
      if (list[i].color) {
        color = list[i].color._ || list[i].color;
      } else {
        color = "#0693e3";
      }

      let selected = true;
      if (i > 0) {
        selected = false;
      }

      if (list[i].resourcetype && list[i].resourcetype['deleted-calendar'] === undefined) {
        listParse.push({
          accessRole: roll,
          backgroundColor: color,
          colorId: color,
          defaultReminders: [],
          id: list[i].href,
          primary: primary,
          selected: selected,
          summary: list[i].name,
          description: list[i].description,
          timeZone: "Europe/Madrid"
        });
      }
    }
  }

  let items;
  items = ({ items: listParse });
  return items;
}


export const createCalendarUser = async (name, idNavision, idEntrada, account, password, token) =>
  new Promise((resolve, reject) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      displayName: name,
      email: account,
      groups: [
        idNavision
      ],
      password: password,
      userid: account
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${window.PATH_GW_ACC}/${window.API_V2}/nx/nextcloud/${idNavision}/${idEntrada}/createUser`, requestOptions)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(`Status:${response.status} ` + ` Headers:${response.headers}`);
      })
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        console.error('error', error);
        reject(error);
      });
  });

export const createPersonalCalendarUser = async (user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });
  const response = await cd.createPersonalCalendar();
  return response;
};

export const searchUsers = async (idNavision, token) => new Promise((resolve, reject) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", token);

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  fetch(`${window.PATH_GW_ACC}/${window.API_V2}/nx/nextcloud/${idNavision}/users/search`, requestOptions)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Status:${response.status} ` + ` Headers:${response.headers}`);
    })
    .then(result => {
      resolve(result);
    })
    .catch(error => {
      console.error('error', error);
      reject(error);
    });
});

export const getEventDataById = (event, calendarId) => {
  const start = event.start.dateTime;
  const end = event.end.dateTime;

  // Recurrence
  let recurrenceRule;
  if (event.recurrence != undefined) {
    recurrenceRule = event.recurrence[0].replace('RRULE:', '');
  }
  // Attendees
  let attendees = [];
  if (event.attendees != undefined) {
    attendees = event.attendees;
  } else {
    attendees = undefined;
  }
  // EventType
  const eventType = {};
  if (event.categories != undefined) {
    eventType.name = event.categories;
    eventType.color = event.color;
  }

  let reminders = [];
  if (event.reminders != undefined) {
    reminders = event.reminders;
  }

  const eventData = {
    Id: event.id,
    CalendarId: calendarId,
    filename: event.filename,
    Subject: event.summary,
    Location: event.location,
    Description: event.description,
    StartTime: new Date(start),
    EndTime: new Date(end),
    IsAllDay: event.IsAllDay,
    Visibility: event.visibility,
    RecurrenceRule: recurrenceRule,
    ImageName: "icon-lefebvre-bl",
    Attendees: attendees,
    EventType: eventType,
    Reminders: reminders,
    LexonClassification: event.lexonActuation,
    CompanySelected: event.companySelected,
    IdCompanySelected: event.idCompanySelected,
    IdEventAction: event.idEventAction
  };

  return eventData;
};
